import React from 'react'
import {RolesList} from '../../role-management/roles-list/RolesList'

const RolesPage: React.FC = () => {
  return (
    <div className="roles-page">
      <div className="d-flex flex-column flex-lg-row">
        <div className="flex-lg-row-fluid me-lg-15">
          <RolesList />
        </div>
      </div>
    </div>
  )
}

export default RolesPage 